module.exports = __webpack_public_path__ + "static/img/home-4.c35b01b6.png";